// Species registry. Adding a species is one entry here plus one folder under
// public/species/<id>/ (butterfly.glb, photo.jpg, LICENSE.txt, notes.md).
//
// Species are not chosen yet (HANDOVER Section 3). species-a is the prototype
// model (a Monarch, see public/species/species-a/notes.md). species-b is a
// blue recolour of the same model with its own timing (see
// public/species/species-b/notes.md); it shares species-a's silhouette, which
// a real second species must not. Facts copy is placeholder until
// Fjärilshuset supplies text. Photos do not exist yet.
//
// wingspanM: real-world wingspan the butterfly should have on screen.
// modelWingspanM: the wingspan the glb was measured at (notes.md). The app
// scales the model by wingspanM / modelWingspanM.
export const species = [
  {
    id: 'species-a',
    names: {
      en: { common: 'Monarch', scientific: 'Danaus plexippus' },
      sv: { common: 'Monarkfjäril', scientific: 'Danaus plexippus' },
    },
    model: '/species/species-a/butterfly.glb',
    photo: '/species/species-a/photo.jpg',
    wingspanM: 0.1,
    modelWingspanM: 0.1,
    tint: null,
    facts: {
      en: {
        body1: 'Wingspan 9–10 cm. Famous for its migration: every autumn millions fly from Canada and the United States to a few mountain forests in Mexico.',
        body2: 'The orange and black is a warning. Monarch caterpillars eat milkweed, which makes the adult butterfly taste bad to birds.',
      },
      sv: {
        body1: 'Vingbredd 9–10 cm. Känd för sin flyttning: varje höst flyger miljontals från Kanada och USA till några få bergsskogar i Mexiko.',
        body2: 'Det orangea och svarta är en varning. Monarkens larver äter sidenört, vilket gör den vuxna fjärilen illasmakande för fåglar.',
      },
    },
    placeholderPhoto: 'radial-gradient(70% 70% at 50% 40%, #E3A55A 0%, #9A5B2A 60%, #5E3618 100%)',
  },
  {
    id: 'species-b',
    names: {
      en: { common: 'Blue morpho', scientific: 'Morpho peleides' },
      sv: { common: 'Blå morpho', scientific: 'Morpho peleides' },
    },
    model: '/species/species-b/butterfly.glb',
    photo: '/species/species-b/photo.jpg',
    wingspanM: 0.115,
    modelWingspanM: 0.115,
    tint: null,
    crossfade: 0.4, // land ends open, idle starts closed (notes.md): a longer blend hides the join
    facts: {
      en: {
        body1: 'Wingspan 12–15 cm. Lives in the rainforests of Central and South America, from Mexico to Colombia.',
        body2: 'The blue is not a pigment. Tiny ridges on the wing scales bend the light, so the colour shifts as the wings move.',
      },
      sv: {
        body1: 'Vingbredd 12–15 cm. Lever i regnskogarna i Central- och Sydamerika, från Mexiko till Colombia.',
        body2: 'Det blå är inget pigment. Små åsar på vingfjällen bryter ljuset, så färgen skiftar när vingarna rör sig.',
      },
    },
    placeholderPhoto: 'radial-gradient(70% 70% at 50% 40%, #6FA0D9 0%, #2F5C9A 60%, #1E3F6E 100%)',
  },
];

export const speciesById = Object.fromEntries(species.map((s) => [s.id, s]));
